<template>
<div class="bg-light">
  <Banner class="sticky-top bg-light" />
  <b-container>
    <b-row>
      
      <!-- Banner section -->
      
      <b-col
	class="order-2 order-sm-1"
	cols="12">
	<b-container class="px-0"> 
	  <ConstructionBanner>
	    <!--b-img :src="require('../assets/pdf_icon.png')" class="p-2 p-sm-0 mb-2" style="height: 170px; width: 170px;" slot="icon"></b-img-->
	    <b-img
	      :src="require('../assets/trinapp_crosslink.png')"
	      class="p-2 p-sm-0 mb-2"
	      style="height: 170px;"
	      slot="icon"
	      />
	    <!--h4 slot="icon-title">Trinity PDF&trade;</h4-->
	    <h4 slot="icon-title" class="font-weight-bold">Trinity Crosslink&trade;</h4>
	    <h4 slot="description-title"><small class="text-secondary">(Patent Pending)</small></h4>
	    <h4 slot="description">Trinity_AI powered linking of drawings and specs so you can find documents faster.</h4>
	  </ConstructionBanner>
	</b-container>
      </b-col>
      
      <!-- Tab section -->
      
      <b-col class="order-1 order-sm-2" cols="12">
	<b-container class="px-0">         
	    <b-row>
	      <b-col>	
		<ProductsTab activeProductTab="pdf" />
	      </b-col>
	    </b-row>
	</b-container>
      </b-col>
      
      <!-- Content section -->
      
      <b-col
	class="order-3"
	cols="12"
	>
	<b-row>
	  <b-col>
	    <div class="p-2 p-sm-5 bg-white">
	      <h1 class="mb-3" style="font-weight: 400;">GraphMetrix saves you <span class="gmx-red">time</span> by:</h1>
	      <b-container>
		<b-row class="pb-2">
		  <b-col cols="12" lg="6">
		    <ul>
		      <li><h3 style="font-weight: 400;">Automatically highlighting all page <span class="gmx-red">links</span> in the drawing set and between specs and drawings for <span class="gmx-red">instant navigation</span>, whether in a full set PDF or in separate page PDFs</h3></li>
		      <li><h3 style="font-weight: 400;">Adding a navigation bar of links to the PDF with home button, previous and next section and page to allow <span class="gmx-red">fast contextual navigation</span></h3></li>
		      <li><h3 style="font-weight: 400;">All links and navigation controls work in all standard PDF viewers both desktop and mobile</h3></li>
		    </ul>
		  </b-col>
		  <b-col cols="12" lg="6">
		    <b-container>
		      <b-row class="text-center">
			<b-col cols="6">
			  <figure>
			    <b-img :src="require('../assets/Porsche-dwgs2-lnk-7-crop.png')" class="border border-secondary" fluid></b-img>
			    <figcaption><small>Drawing with Trinity-created links and navigation</small></figcaption>
			  </figure>
			</b-col>
			<b-col cols="6">
			  <figure>
			    <b-img :src="require('../assets/Porsche-specs2-lnk-3.png')" class="border border-secondary" fluid></b-img>
			    <figcaption><small>Specs sheet with Trinity-created links and navigation</small></figcaption>
			  </figure>
			</b-col>
		      </b-row>
		      <b-row>
			<figure>
			  <b-img :src="require('../assets/Porsche-dwgs2-lnk-21-crop.png')" class="border border-secondary" fluid></b-img>
			</figure>
			<figcaption>
			  <small>The navbar and links (colored green) are automatically written to the PDF by Trinity</small>
			</figcaption>
		      </b-row>
		    </b-container>
		  </b-col>
		</b-row>
	      </b-container>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <div class="p-2 p-sm-5 bg-light">
	      <h1 class="mb-3" style="font-weight: 400;"><span class="gmx-red">Quality and control</span> reporting:</h1>
	      <b-container>
		<b-row>
		  <b-col cols="12" lg="5">
		    <ul>
		      <li><h3 style="font-weight: 400;"><span class="gmx-red">Excel reports</span> are generated automatically for both drawings and specs listing all automatically captured metadata</h3>
		      </li>
		    </ul>
		  </b-col>
		  <b-col cols="12" lg="7">
		    <b-img :src="require('../assets/trinity_pdf_spreadsheets.png')" class="border border-secondary" fluid></b-img>
		  </b-col>
		</b-row>
	      </b-container>
	    </div>
	  </b-col>
	</b-row>
      </b-col>
    </b-row>
      
  </b-container>
  <GmxFooter />
</div>
</template>

<script>
// @ is an alias to /src
const $ = require('jquery')
import * as log from 'loglevel'
import Banner from '@/components/gmx-banner.vue';
import ConstructionBanner from '@/components/construction-banner.vue';
import ProductsTab from '@/components/products-tab.vue';
import GmxFooter from '@/components/footer.vue';
export default {
    name: 'ConstructionPdf',
    components: {
	Banner,
	ConstructionBanner,
	ProductsTab,
	GmxFooter
    },
    methods: {
	img: function (image) {
	    require(image)
	}
    }
};
</script>

<style>
.gmx-purple {
  color: #2e145e;
}
.gmx-red {
  color: #ff0000;
}
.cover-background {
    background-image: url('../assets/toolkit_cover_background.png');
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
